module.exports = __webpack_public_path__ + "static/img/ic_prev.68cff321.png";